import "./TraderSearch.css";

const TraderSearchBox = (props) => {
  return <div className="trader__searchBox">{props.children}</div>;
};

export default TraderSearchBox;
